// eslint-disable-next-line
import {
  deleteCompany,
  getAllCompanies,
} from '@/api/index';
import { Mixin } from 'mc-js-lib';

export default {
  namespaced: 'Dashboard',
  state() {
    return ({
      companies: [],
      companySelected: {},
      loadingCompanies: false,
      isReloading: false,
    });
  },
  getters: {

  },
  mutations: {
    setCompanies(state, companiesList) {
      state.companies = companiesList;
      setTimeout(() => { Mixin.methods.G_triggerResizeEven(); }, 10);
    },
    setCompanySelected(state, company) {
      if (company) {
        state.companySelected = company;
      }
    },
    setLoading(state, status) {
      state.loadingCompanies = status;
    },
    reloadTable(state, reload) {
      state.isReloading = reload;
    },
  },
  actions: {
    async apiGetUsers({
      commit,
      state,
    }) {
      commit('setLoading', true);
      await getUsersCustomer(null).then((res) => {
        if (res.users) {
          commit('setUsers', res.users.filter((user) => !user.deleted));
          if (state.users.length) {
            commit('setUserSelected', state.users[0]);
          }
        }
      });
      commit('setLoading', false);
    },

    async apiGetAllCompanies({
      commit,
      state,
    }) {
      commit('setLoading', true);
      await getAllCompanies({ page: 1, rows: 10 }).then((res) => {
        if (res.companies) {
          commit('setCompanies', res.companies.filter((company) => !company.deleted));
          if (state.companies.length) {
            commit('setCompanySelected', state.companies[0]);
          }
        }
      });
      commit('setLoading', false);
    },

    async apiDeleteCompany({
      commit,
      state,
    }) {
      await deleteCompany(state.companySelected.company_id).then((res) => {
        commit('setCompanies', state.companies.filter((usr) => usr.company_id !== res.user_id));
        commit('setUserSelected', state.companies[0]);
      });
    },

  },
};
